import angular from "angular";
import { directiveFactory } from "../angular-core";

export class NgHtmlCompileDirective implements ng.IDirective {
    static componentName: string = "ngHtmlCompile";
    static $inject = ["$compile"];
    restrict = "A";
    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
        scope.$watch(attrs.ngHtmlCompile, (newValue: $TSFixMe, oldValue: $TSFixMe) => {
            element.html(newValue);
            this.$compile(element.contents() as any)(scope);
        });
    };
    constructor(protected $compile: ng.ICompileService) {}
}

angular
    .module("topline.directives")
    .directive(NgHtmlCompileDirective.componentName, directiveFactory(NgHtmlCompileDirective));